import React from "react";
import { COLOR_GRAY_BANNER_BACKGROUND } from "../../constants/general-constants";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useHistory } from 'react-router-dom';

export default function LeftMenu() {

    const history = useHistory();

    const thisContainer = {

        display: 'flex',
        position: "fixed",
        background:
            "linear-gradient(180deg,#1e293b 0%, #0f172a 100%)",
        flexDirection: "column",
        alignItems: "center",
        width: "40px",
        left: "0px",
        top: "105px",
        borderTopRightRadius: "8px",
        borderBottomRightRadius: "8px",
        borderRight:
            "1px solid rgba(255,255,255,0.06)",
        boxShadow:
            "0 8px 24px rgba(0,0,0,0.35)",
        zIndex: "2000",
        paddingTop: "20px",
        paddingBottom: "20px",
        gap: "20px"
    };

    const blankFunction = () => {
    };

    const goLogout = () => {
        history.push('/logout');
    };

    const goHome = () => {
        history.push('/');
    };

    const goAdministration = () => {
        history.push('/administration');
    };

    const goBack = () => {
        history.goBack();
    };

    const iconWrapperStyle = {

        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "28px",
        height: "28px",
        borderRadius: "50%",
        cursor: "pointer",
        background:
            "linear-gradient(180deg,#334155 0%, #1e293b 100%)",
        border:
            "1px solid rgba(255,255,255,0.06)",
        boxShadow:
            "0 4px 10px rgba(0,0,0,0.28)",
        transition: "all 0.2s ease"
    };

    const iconStyle = {

        color: "#ffffff",
        width: "16px",
        height: "16px",
        transition: "all 0.2s ease"

    };

    return (

        <div style={thisContainer}>

            {/* HOME */}
            <div
                style={iconWrapperStyle}
                title="Home"
                onClick={goHome}
                onMouseEnter={(e) => {

                    e.currentTarget.style.background =
                        "linear-gradient(180deg,#6baee6 0%, #5a9bd6 45%, #4a8ac4 100%)";

                    e.currentTarget.style.transform =
                        "translateY(-2px) scale(1.05)";

                    e.currentTarget.style.boxShadow =
                        "0 8px 18px rgba(90,155,214,0.45)";

                }}
                onMouseLeave={(e) => {

                    e.currentTarget.style.background =
                        "linear-gradient(180deg,#334155 0%, #1e293b 100%)";

                    e.currentTarget.style.transform =
                        "translateY(0px) scale(1)";

                    e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0,0,0,0.28)";

                }}
            >
                <FontAwesomeIcon icon="home" style={iconStyle} />
            </div>

            {/* USER */}
            <div
                style={iconWrapperStyle}
                title="Logout"
                onClick={goLogout}
                onMouseEnter={(e) => {

                    e.currentTarget.style.background =
                        "linear-gradient(180deg,#6baee6 0%, #5a9bd6 45%, #4a8ac4 100%)";

                    e.currentTarget.style.transform =
                        "translateY(-2px) scale(1.05)";

                    e.currentTarget.style.boxShadow =
                        "0 8px 18px rgba(90,155,214,0.45)";

                }}
                onMouseLeave={(e) => {

                    e.currentTarget.style.background =
                        "linear-gradient(180deg,#334155 0%, #1e293b 100%)";

                    e.currentTarget.style.transform =
                        "translateY(0px) scale(1)";

                    e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0,0,0,0.28)";

                }}
            >
                <FontAwesomeIcon icon="user" style={iconStyle} />
            </div>

            {/* HELP */}
            <div
                style={iconWrapperStyle}
                title="Help"
                onClick={blankFunction}
                onMouseEnter={(e) => {

                    e.currentTarget.style.background =
                        "linear-gradient(180deg,#6baee6 0%, #5a9bd6 45%, #4a8ac4 100%)";

                    e.currentTarget.style.transform =
                        "translateY(-2px) scale(1.05)";

                    e.currentTarget.style.boxShadow =
                        "0 8px 18px rgba(90,155,214,0.45)";

                }}
                onMouseLeave={(e) => {

                    e.currentTarget.style.background =
                        "linear-gradient(180deg,#334155 0%, #1e293b 100%)";

                    e.currentTarget.style.transform =
                        "translateY(0px) scale(1)";

                    e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0,0,0,0.28)";

                }}
            >
                <FontAwesomeIcon icon="question" style={iconStyle} />
            </div>

            {/* SETTINGS */}
            <div
                style={iconWrapperStyle}
                title="Administration"
                onClick={goAdministration}
                onMouseEnter={(e) => {

                    e.currentTarget.style.background =
                        "linear-gradient(180deg,#6baee6 0%, #5a9bd6 45%, #4a8ac4 100%)";

                    e.currentTarget.style.transform =
                        "translateY(-2px) scale(1.05)";

                    e.currentTarget.style.boxShadow =
                        "0 8px 18px rgba(90,155,214,0.45)";

                }}
                onMouseLeave={(e) => {

                    e.currentTarget.style.background =
                        "linear-gradient(180deg,#334155 0%, #1e293b 100%)";

                    e.currentTarget.style.transform =
                        "translateY(0px) scale(1)";

                    e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0,0,0,0.28)";

                }}
            >
                <FontAwesomeIcon icon="gear" style={iconStyle} />
            </div>

            {/* BACK */}
            <div
                style={iconWrapperStyle}
                title="Back"
                onClick={goBack}
                onMouseEnter={(e) => {

                    e.currentTarget.style.background =
                        "linear-gradient(180deg,#6baee6 0%, #5a9bd6 45%, #4a8ac4 100%)";

                    e.currentTarget.style.transform =
                        "translateY(-2px) scale(1.05)";

                    e.currentTarget.style.boxShadow =
                        "0 8px 18px rgba(90,155,214,0.45)";

                }}
                onMouseLeave={(e) => {

                    e.currentTarget.style.background =
                        "linear-gradient(180deg,#334155 0%, #1e293b 100%)";

                    e.currentTarget.style.transform =
                        "translateY(0px) scale(1)";

                    e.currentTarget.style.boxShadow =
                        "0 4px 10px rgba(0,0,0,0.28)";

                }}
            >
                <FontAwesomeIcon icon="arrow-left" style={iconStyle} />
            </div>

        </div>

    );

}